import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isToast: false,
  type: "",
  message: "",
};

export const toastSlice = createSlice({
  name: "Toast Message",
  initialState,
  reducers: {
    setToast: (state, action) => {
      state.isToast = true;
      state.type = action.payload.type;
      state.message = action.payload.message;
    },
    clearToast: (state) => {
      state.isToast = false;
      state.type = "";
      state.message = "";
    },
  },
});

export const { setToast, clearToast } = toastSlice.actions;

export default toastSlice.reducer;
